module.exports = __webpack_public_path__ + "img/login_logo.bf9a20fd.png";